import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

export const fetchArticleGenerationForTopicsUrl = (projectId: number, activationId: string) =>
	`${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topics/draft-article/generate`;

export const fetchArticleGenerationForTopics = (
	projectId: number,
	activationId: string,
): Promise<void> => {
	const url = fetchArticleGenerationForTopicsUrl(projectId, activationId);
	return performPostRequest(url);
};
